import { Text, View } from 'react-native'
import { Image as ExpoImage } from 'expo-image'
import { HERO_IMAGE } from '@/src/features/onboarding/constants/onboardingStyles'

export function PurchaseHero({
  heroHeight,
  isRevenueCatTestStore,
  testStoreLabel,
}: {
  heroHeight: number
  isRevenueCatTestStore: boolean
  testStoreLabel: string
}) {
  return (
    <View
      className="relative w-full overflow-hidden"
      style={{ height: heroHeight }}
    >
      <ExpoImage
        source={HERO_IMAGE}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          width: '100%',
          height: '100%',
        }}
        contentFit="cover"
        contentPosition={{ top: 0, left: 0 }}
        transition={1000}
      />
      {isRevenueCatTestStore && (
        <View className="absolute top-12 left-0 right-0 items-center">
          <View className="bg-warning px-3 py-1 rounded-full">
            <Text className="text-[10px] text-warning-foreground font-bold uppercase tracking-wider">
              {testStoreLabel}
            </Text>
          </View>
        </View>
      )}
    </View>
  )
}
